import { 
  Box, 
  Typography, 
  List, 
  ListItem, 
  Avatar,
  IconButton,
  Tooltip,
  Alert
} from '@mui/material';
import { Add as AddIcon, Edit as EditIcon } from '@mui/icons-material';
import { useTeam } from '../../contexts/TeamContext';
import { useState, useCallback, useEffect } from 'react';
import AddTeamMemberDialog from '../team/AddTeamMemberDialog';
import EditTeamMemberDialog from '../team/EditTeamMemberDialog';
import { useAuth } from '../../contexts/AuthContext';
import { getAuth } from 'firebase/auth'; // Add this import
import { useNavigate, useLocation } from 'react-router-dom';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';

export default function LeftNavigation() {
  const { teamMembers, selectedMember, setSelectedMember, updateTeamMember, deleteTeamMember, addTeamMember } = useTeam();
  const { user } = useAuth();
  const auth = getAuth(); // Add this line
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [editMember, setEditMember] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const hasTeamMembers = teamMembers && teamMembers.length > 0;

  console.log('LeftNavigation - teamMembers:', teamMembers); // Debug log
  console.log('LeftNavigation - selectedMember:', selectedMember); // Debug log

  useEffect(() => {
    console.log('LeftNavigation - useEffect - teamMembers:', teamMembers); // Debug log
    console.log('LeftNavigation - useEffect - selectedMember:', selectedMember); // Debug log
    if (!selectedMember && teamMembers.length > 0) {
      setSelectedMember(teamMembers[0]);
    }
  }, [teamMembers, selectedMember, setSelectedMember]);

  const handleAddTestMember = async () => {
    try {
      console.log('Current auth user:', auth.currentUser); // Debug log
      console.log('Context user:', user); // Debug log
      
      if (!auth.currentUser) {
        console.error('No authenticated user');
        return;
      }

      await addTeamMember({
        name: "Test User",
        email: "test@example.com",
        role: "Developer"
      });
      console.log("Test member added successfully");
    } catch (error) {
      console.error("Error adding test member:", error);
    }
  };

  const handleTeamMemberClick = useCallback((member) => {
    setSelectedMember(member);
  }, [setSelectedMember]);

  const handleEditClick = (e, member) => {
    e.stopPropagation();
    setEditMember(member);
  };

  const handleUpdateMember = async (formData) => {
    try {
      const memberRef = doc(db, 'teams', editMember.id);
      await updateDoc(memberRef, {
        name: formData.name,
        email: formData.email,
        role: formData.role,
        jobFunction: formData.jobFunction
      });
      setEditMember(null);
    } catch (error) {
      console.error('Error updating team member:', error);
    }
  };

  const handleDeleteMember = async (member) => {
    try {
      if (!member || !member.id) {
        console.error('Invalid member object:', member);
        return;
      }
      
      await deleteTeamMember(member);
      setEditMember(null);
      
      if (selectedMember?.id === member.id) {
        setSelectedMember(null);
      }
    } catch (error) {
      console.error('Error deleting team member:', error);
    }
  };

  return (
    <Box sx={{ p: 3, width: 280 }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        mb: 2,
        width: '280px'
      }}>
        <Typography sx={{ 
          fontSize: '12px',
          color: '#666666',
          fontWeight: 500,
        }}>
          TEAM MEMBERS
        </Typography>
        <Tooltip
                title="Add a team member"
                placement="top"
                TransitionProps={{ style: { transitionDuration: '0.15s' } }}
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, -10], // [x-offset, y-offset] in pixels
                        },
                      },
                    ],
                  },
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: '#242424',
                    }
                  }
                }}
              >
        <IconButton 
          onClick={() => setIsAddDialogOpen(true)}
          sx={{ 
            color: '#3366FF',
            p: 0.5,
            '&:hover': {
              bgcolor: 'rgba(51, 102, 255, 0.04)'
            }
          }}
        >
          <AddIcon />
        </IconButton>
        </Tooltip>
      </Box>

      {!hasTeamMembers && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Please add team members before creating meetings
        </Alert>
      )}

      <List sx={{ pt: 0 }}>
        {teamMembers.map((member) => (
          <ListItem 
            key={member.id}
            disableRipple
            onClick={() => handleTeamMemberClick(member)}
            sx={{
              borderRadius: 2,
              mb: 1,
              cursor: 'pointer',
              bgcolor: member.id === selectedMember?.id ? '#FFFFFF' : 'transparent',
              boxShadow: member.id === selectedMember?.id ? "0px 4px 13px rgba(0, 0, 0, 0.25)" : "none",
              transition: 'background-color 0.2s ease',
              '&:hover': {
                bgcolor: member.id === selectedMember?.id ? '#FFFFFF' : '#F0F0F0',
                '& .edit-icon': {
                  opacity: 1
                }
              },
              padding: '24px',
              position: 'relative',
              width: '280px'
            }}
          >
            <Avatar 
              sx={{ 
                mr: 2,
                width: 40,
                height: 40,
                bgcolor: member.id === selectedMember?.id ? '#E8EBF4' : '#F0F0F0',
                color: member.id === selectedMember?.id ? '#3366FF' : '#666666'
              }}
            >
              {member.name?.split(' ').map(n => n[0]).join('')}
            </Avatar>
            <Box>
              <Typography
                sx={{
                  fontSize: '18px',
                  fontWeight: member.id === selectedMember?.id ? 600 : 500,
                  color: '#000000',
                  mb: 0.5
                }}
              >
                {member.name}
              </Typography>
              <Typography
                sx={{
                  fontSize: '12px',
                  color: '#666666',
                  textTransform: 'uppercase'
                }}
              >
                {member.role}
              </Typography>
            </Box>
            <IconButton
              className="edit-icon"
              onClick={(e) => handleEditClick(e, member)}
              sx={{
                position: 'absolute',
                right: 8,
                opacity: 0,
                transition: 'opacity 0.2s ease',
                color: '#666666',
                p: 1
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </ListItem>
        ))}
      </List>

      <AddTeamMemberDialog 
        open={isAddDialogOpen}
        onClose={() => setIsAddDialogOpen(false)}
        onTeamMemberAdded={() => setIsAddDialogOpen(false)}
      />

      {editMember && (
        <EditTeamMemberDialog
          open={!!editMember}
          onClose={() => setEditMember(null)}
          member={editMember}
          onUpdate={handleUpdateMember}
          onDelete={handleDeleteMember}
        />
      )}
    </Box>
  );
}